module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.newValue) ? _c('div', {
    staticClass: "quantity-selection--item"
  }, [_c('select', {
    staticClass: "quantity-selection--select notranslate",
    class: {
      'is-selected': this.newValue > 0
    },
    attrs: {
      "name": _vm.item.value,
      "id": _vm.item.value
    },
    on: {
      "change": _vm.change
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.item.name) + ": " + _vm._s(_vm.newValue))]), _vm._v(" "), _vm._l((_vm.selectRange), function(number) {
    return _c('option', {
      key: number - 1,
      domProps: {
        "value": number - 1
      }
    }, [_vm._v("\n      " + _vm._s(number - 1) + "\n    ")])
  })], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07e4f327","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/QuantitySelectionItem.vue
// module id = 1807
// module chunks = 0